import { Link, useNavigate } from "react-router-dom";

const RacingGameTableRow = ({ row, inplay }) => {
    const navigate = useNavigate();
    return (
        <>
            <div className='block bg-[#fff] pl-[10px] pr-[6px] py-[0] relative !w-full  overflow-x-auto'>
                <dt className="float-none w-auto font-bold">
                    <div href="#" className="!text-[#000] pt-[5px] px-[0] pb-[13px] align-middle">Philadelphia (US) 27th Jan</div>
                </dt>
                <dd className="border-b-[1px_solid_#e0e6e6] h-[29px] mb-0 pb-0 float-none w-auto ml-0">
                    <ul className="m-0 p-0">
                        <li className="inline">
                            <a title="R1 6f Claim" className="bg-[#6bbd11] border-[#6bbd11] text-[#fff] border-[1px]  border-[transparent] rounded-[3px] text-[13px] leading-[19px] mr-[5px] cursor-pointer px-[8px] py-[7px]">22:35</a>
                        </li>
                        <li className="inline">
                            <a title="R1 6f Claim" className="text-[#000] bg-[#e8e8e8] border-[1px] border-[transparent] hover:border-[#27a6c3] rounded-[3px] text-[13px] leading-[19px] mr-[5px] cursor-pointer px-[8px] py-[7px]">22:35</a>
                        </li>
                    </ul>
                </dd>
            </div >


        </>
    );
};

export default RacingGameTableRow;
